import { render, staticRenderFns } from "./CollectionGroupPerformanceLock.vue?vue&type=template&id=ef0aea02&scoped=true"
import script from "./CollectionGroupPerformanceLock.vue?vue&type=script&lang=js"
export * from "./CollectionGroupPerformanceLock.vue?vue&type=script&lang=js"
import style0 from "./CollectionGroupPerformanceLock.vue?vue&type=style&index=0&id=ef0aea02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0aea02",
  null
  
)

export default component.exports